/**
 * NewHireJourneyTag Component
 * Fetches journey by ID and renders a JourneyTag
 */

import { Box, Tooltip, Skeleton } from "@chakra-ui/react";
import { useNavigate } from "react-router";
import CDS from "design-system";
import { useNewHireJourneyDetailQuery } from "features/NewHireJourney/hooks";
import { newHireJourneyPathById } from "helpers/url";

interface NewHireJourneyTagProps {
  journeyId: string;
  size?: "sm" | "md";
  linkTo?: string;
  clickable?: boolean;
  bordered?: boolean;
}

export default function NewHireJourneyTag({ journeyId, size = "sm", linkTo, clickable = false, bordered }: NewHireJourneyTagProps) {
  const navigate = useNavigate();
  const { data: journey, isLoading } = useNewHireJourneyDetailQuery(journeyId);

  const resolvedLinkTo = linkTo ?? (clickable ? newHireJourneyPathById(journeyId) : undefined);
  const handleClick = resolvedLinkTo ? () => navigate(resolvedLinkTo) : undefined;

  if (isLoading) {
    return <Skeleton height="24px" width="80px" borderRadius="full" />;
  }

  if (!journey?.newHire?.fullName) {
    return null;
  }

  return (
    <Tooltip label={`${journey.newHire.fullName}'s Onboarding Journey`} placement="top">
      <Box display="inline-block">
        <CDS.JourneyTag name={journey.newHire.fullName} size={size} onClick={handleClick} bordered={bordered} />
      </Box>
    </Tooltip>
  );
}
